module.exports = __webpack_public_path__ + "img/92c5914.png";